import Repository from "../Repository";

const resource = "/campaigns";
export default {
    get(){
        return Repository.get(`${resource}`);
    },
    getCampaign(campaignId, withRelations){
        return Repository.get(`${resource}/${campaignId}`+ (withRelations ? '?withRelations=1' : ''))
    },
    create(json){
        return Repository.post(`${resource}`,json);
    },
    updateCampaign(campaignId,json){
        return Repository.put(`${resource}/${campaignId}`,json);
    },
    updateComment(campaignId,json){
        return Repository.put(`campaign/comment/${campaignId}`,json);
    },
    copyCampaign(campaignId){
        return Repository.post(`${resource}/${campaignId}/copy`);
    },
    deleteCampaign(campaignId){
        return Repository.delete(`${resource}/${campaignId}`);
    }
}